// frontend/src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// import { AppContext } from '../../AppContext';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = () => {
  const { isAuthenticated, isSessionLoading } = useContext(AuthContext);

  // The environment variable for bypassing auth during development
  const authBypass = process.env.REACT_APP_AUTH_ENABLED === 'false';

  // 1. If the session is still being checked, don't render anything yet.
  //    You could also render a full-page loading spinner here.
  if (isSessionLoading) {
    return null; // or <LoadingSpinner />;
  }

  // 2. Once loading is complete, check for authentication.
  if (authBypass || isAuthenticated) {
    return <Outlet />;
  }
  
  // 3. If loading is complete and user is not authenticated, redirect.
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;